var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-menu',_vm._b({attrs:{"items":_vm.items,"align":"rr;bb"},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(index,name){return {key:name,fn:function(slotData){return [_vm._t(name,null,null,slotData)]}}})],null,true)},'v-menu',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }